import styled from 'styled-components';

export const Wrapper = styled.div`
 display: grid;
 
 place-content:center;
 background-color: beige;
 color:black;
 
`;

export const Content = styled.div`
 
    display: grid;
    grid-auto-flow: column;
    
    
    max-width:200px;
    color: black;
    
`;

